import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(VAutocomplete, {
    staticClass: "input-with-add-button",
    attrs: {
      "value": _vm.value,
      "items": _vm.selectOptions,
      "label": _vm.label,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "color": _vm.color,
      "loading": _vm.isLoadingOptions,
      "disabled": _vm.isLoadingOptions,
      "dense": _vm.dense,
      "hide-details": "",
      "clearable": "",
      "data-cy": "autocomplete_value"
    },
    on: {
      "input": function ($event) {
        return _vm.$emit('input', $event);
      }
    },
    scopedSlots: _vm._u([{
      key: "no-data",
      fn: function () {
        return [_c(VListItem, [_c(VListItemContent, [_c(VListItemTitle, [_vm._v("\n          " + _vm._s(_vm.$i18n_t('Core.MultiSearch.noData.options')) + "\n        ")])], 1)], 1)];
      },
      proxy: true
    }, {
      key: "append-outer",
      fn: function () {
        return [_c('core-button', {
          staticClass: "rule-add-button",
          attrs: {
            "color": _vm.color,
            "disabled": !_vm.canAddRule,
            "prepend-icon": "fa-plus",
            "data-cy": "button_add_rule"
          },
          on: {
            "click": function ($event) {
              return _vm.$emit('add-rule');
            }
          }
        })];
      },
      proxy: true
    }])
  });
};
var staticRenderFns = [];
export { render, staticRenderFns };